import {  Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import {  useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomIconSelect from "../expenseModule/defaultSelectIcon";
import { validetPrifix } from "jsFunctions/generatePoNumber";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { useToasts } from "react-toast-notifications";
import orgJson from "components/jsonData/orgnization.json";
import { fetchAsyncUpdateOrganizationModuleType } from "redux/organizationModuleSlice";
import { formatStrWithColon } from "jsFunctions/generatePoNumber";
import { generatePOPrefix } from "jsFunctions/generatePoNumber";
import { fetchAsyncCreateOrganizationModuleType } from "redux/organizationModuleSlice";
import { moduleTypeOption } from "./moduleUtils";
import { moduleIcon } from "./moduleIcon";

const  AddModuleForm=({isOpen,onClose,isEdit,editData})=> {
    const [errors,setErrors] = useState({})
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const [formData,setFormData] = useState({
        moduleName:"",
        moduleType:"",
        prifix:"",
        color:"",
        icnImg:""
      })

    useEffect(() => {
      if (editData && isEdit) {
        setFormData({
          moduleName: editData?.name,
          moduleType: editData?.typ,
          prifix: editData?.prfx,
          color: editData?.clr || "",
          icnImg: editData?.icnImg,
        });
      }
    }, [editData, isEdit]);
      const validate = () => {
        const newErrors = {};
    
        if (!formData.moduleName)
          newErrors.moduleName = "Module name is required!"
        if (!formData.moduleType)
          newErrors.moduleType = "Module type is required!"
        if (!formData.prifix)
          newErrors.prifix = "prifix is required!"
        if(formData.prifix && !validetPrifix(formData.prifix)){
          newErrors.prifix = "Prifix is invalid. It must be between 5 and 9 characters long."
        }
        setErrors(newErrors);
    
        return Object.keys(newErrors).length === 0;
      };
      const toCamelCase = (value) => {
        return value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(" ");
      };
      
      const handleCreateOrganizationModule = (data) => {
        
        const formDataToSend = new FormData();
        formDataToSend.append("formdata", JSON.stringify(formData));
    
        dispatch(fetchAsyncCreateOrganizationModuleType(formDataToSend))
          .then((res) => {
            if (res?.payload) {
              addToast(orgJson.success.createModule, { appearance: "success" });
              onClose()
            } else {
              addToast(res?.error?.message, { appearance: "error" });
            }
          })
          .catch((error) => {
            addToast(orgJson.error.generic, { appearance: "error" });
          });
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        let formattedValue = value;
          let defaultPrfx = formData.prifix || "";
          if(name === 'moduleName'){
            formattedValue = toCamelCase(value);
          }
          if(name === 'moduleType'){
            defaultPrfx = generatePOPrefix(value)
          }
          
          setFormData((prev) => ({
            ...prev,
            [name]: formattedValue,
            prifix: defaultPrfx
          }));
        
      };
    
      const handleAddModule = (e) => {
        e.preventDefault();
        if (validate()) {
          ConfirmationDialog({
            title: "Are you sure? You want to create module",
            text: `Module Name : ${formData?.moduleName} , Module Type: ${formData?.moduleType}`,
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            onConfirm: () => {
              handleCreateOrganizationModule(formData)
            },
          });
        } 
      };
    
      const handleEditModule = (e) => {
        e.preventDefault();
        if (validate()) {
          const formDataToSend = new FormData();
          formDataToSend.append("formdata", JSON.stringify(formData));
          dispatch(fetchAsyncUpdateOrganizationModuleType({id:editData?._id,data:formDataToSend}))
          .then((res) => {
            if (res?.payload) {
              addToast(orgJson.success.updateModule, { appearance: "success" });
              onClose()

            } else {
              addToast(res?.error?.message, { appearance: "error" });
            }
          })
          .catch((error) => {
            addToast(orgJson.error.generic, { appearance: "error" });
          });
        } 
      };
    
      const handleChangePrifix = (e) => {
        const { value } = e.target;
        const formattedValue = value.toUpperCase();
        const finalValue = `PR${formattedValue.slice(2)}`;
    
          const formVal = formatStrWithColon(finalValue)
    
          setFormData((prev) => ({
            ...prev,
            prifix: formVal
          }));
        
      };
    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          isCentered
          className=""
        >
          <ModalOverlay />
          <ModalContent maxH="fit-content" className="add-account-user-modal sales-invoice-module-modal">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header">
                {isEdit ? "Edit" : "Add"} Expense Module
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody className="mt-5">
              <Row>
              <Col>
                <Form.Label>
                  <span className="required">Name*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="text"
                  name="moduleName"
                  value={formData?.moduleName}
                  onChange={handleChange}
                  disabled={isEdit}
                />
                {errors?.moduleName && (
                  <p className="form_error">{errors?.moduleName}</p>
                )}
              </Col>
              </Row>
              <Row>
              <Col>
                <Form.Label>
                  <span className="required">Module Type*</span>
                </Form.Label>

                <Form.Select
                  className={`input1 ${isEdit ? "disabled-field" : ""}`}
                  name="moduleType"
                  value={formData?.moduleType}
                  onChange={handleChange}
                  disabled={isEdit}
                >
                  {moduleTypeOption?.map((item) => {
                    return <option value={item?.value}>{item?.name}</option>;
                  })}
                </Form.Select>
                {errors?.moduleType && (
                  <p className="form_error">{errors?.moduleType}</p>
                )}
              </Col>
              </Row>
              <Row>
              <Col>
                <Form.Label>
                  <span className="required">Prifix*</span>
                </Form.Label>
                <Form.Control
                  className={`form-control ${isEdit ? "disabled-field" : ""}`}
                  type="text"
                  name="prifix"
                  disabled={isEdit}
                  value={formData?.prifix}
                  onChange={handleChangePrifix}
                />
                {errors?.prifix && (
                  <p className="form_error">{errors?.prifix}</p>
                )}
              </Col>
              </Row>
              <Row className="icon-color-row">
              <Col>
                <Form.Label>
                  <span>Icon</span>
                </Form.Label>
                <CustomIconSelect
                  icnId={formData?.icnImg}
                  onChange={(e) => handleChange(e)}
                  moduleOption={moduleIcon}

                />
              </Col>
              <Col>
                <Form.Label>
                  <span>Color</span>
                </Form.Label>
                <Form.Control
                  className="form-control color-input-field"
                  type="color"
                  name="color"
                  value={formData?.color}
                  onChange={handleChange}
                />
              </Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <Button onClick={isEdit ? handleEditModule : handleAddModule} className="btn save-btn" mr={3}>
                {isEdit ? "Edit" : "Add"}              
                </Button>
              <Button onClick={onClose} className="btn">
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  export default AddModuleForm;